import { EditBlockPosition } from '@components/EditBuildingBlocks/all'
import { mapActions, mapState } from 'vuex'

export default {
  props: {
    component: {
      type: Object,
      required: true,
    },
    theme: {
      type: Object,
      required: false,
      default: function () {
        return {}
      },
    },
    isGlobalContentItem: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    'edit-block-position': EditBlockPosition,
  },
  computed: {
    ...mapState('editor', [
      'availableFontsList',
      'headlineFontSizesList',
      'textFontSizesList',
      'buttonFontSizesList',
      'textAlignList',
      'flexBoxAlignList',
      'showContentMenu',
      'showSettingsMenu',
    ]),
  },
  created() {
    this.applyThemeStyles()
  },
  methods: {
    ...mapActions('campaign/contentItem',
      ['updateContentItem', 'updateGlobalContentItem']),
    applyThemeStyles() {
      const usesThemeStyles = this.component.settings?.usesThemeStyles ?? false

      if (usesThemeStyles) {
        const themeStyles = this.theme || {}
        const componentStyles = this.component.styling || {}

        // Iterate over the theme styles and update only when there's a difference
        Object.keys(themeStyles).forEach((styleKey) => {
          const themeValue = themeStyles[styleKey]
          const currentComponentValue = componentStyles[styleKey]

          if (currentComponentValue !== themeValue) {
            if (!this.isGlobalContentItem) {
              // Only update when there's a difference
              this.updateContentItem({
                id: this.component.id,
                path: ['styling'],
                attribute: styleKey,
                data: themeValue,
                skipThemeUnlink: true, // Skip theme unlinking
              })
            } else {
              const type = this.component.type === 'wheel'
                ? 'wheel'
                : 'sideImage'

              this.updateGlobalContentItem({
                id: this.component.id,
                itemName: [type],
                path: ['styling'],
                attribute: styleKey,
                data: themeValue,
                skipThemeUnlink: true,
              })
            }
          }
        })
      }
    },
  },
}